<template>
  <div>
    <vx-card
      :title="`Таблица заявок на вызов охраны | Всего: ${totalRequests}`"
      class="p-6"
    >
      <vs-table
        :data="securityRequests"
        :stripe="true"
        :search="false"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="header">
          <div class="header-filter md:w-1/6 w-full mb-5 mr-5 cursor-pointer">
            <v-select
              @input="
                getSecurityRequests(currentPagingationPage, countElements)
              "
              :options="countItemsOmPage"
              :clearable="false"
              placeholder="Количество заявок"
              v-model="countElements"
            >
              <div slot="no-options">Совпадений не найдено</div>
            </v-select>
          </div>
        </template>

        <template slot="thead">
          <vs-th> # </vs-th>
          <vs-th> Дата создания заявки </vs-th>
          <vs-th> Клиент </vs-th>
          <vs-th> Действия </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].id">
              {{ data[indextr].id }}
            </vs-td>

            <vs-td :data="data[indextr].date_created">
              {{ data[indextr].date_created }}
            </vs-td>

            <vs-td :data="data[indextr].full_name">
              <p class="mb-2">
                Автор:
                <span class="text-primary">{{
                  data[indextr].user.full_name
                }}</span>
              </p>
              <p class="mb-2">
                Номер телефона:
                <a
                  class="mb-2 text-primary"
                  :href="`tel:${data[indextr].user.phone}`"
                  >{{ data[indextr].user.phone }}</a
                >
              </p>
              <p class="mb-2">
                Тип поселка:
                <span class="text-primary">{{
                  data[indextr].home.county_type.name
                }}</span>
              </p>
              <p class="mb-2">
                Номер участка:
                <span class="text-primary">{{
                  data[indextr].home.homestead_number
                }}</span>
              </p>
              <p class="mb-2">
                Адрес:
                <span class="text-primary">{{
                  data[indextr].home.address
                }}</span>
              </p>
            </vs-td>
            <vs-td>
              <vs-button
                :to="{ path: `/security/${data[indextr].id}` }"
                color="dark"
                class="text-dark"
                icon-pack="feather"
                icon="icon-eye"
                size="large"
                type="flat"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
    </vx-card>
  </div>
</template>

<script>
import { API_URL, statusType, countyType, countItemsOmPage } from "@/.env";

import { DateTime } from "luxon";

export default {
  data: () => ({
    securityRequests: [],
    statusType: statusType,
    BASE_URL: API_URL,
    activeCreatePrompt: false,
    activeEditPrompt: false,

    countElements: 20,

    currentPagingationPage: 1,
    totalRequests: 0,
    totalPagePagination: 1,
    countItemsOmPage: countItemsOmPage,

    countyType,
    filter: {},
  }),
  components: {
    DateTime,
  },
  watch: {
    countElements: function () {
      this.currentPagingationPage = 1;
    },
    currentPagingationPage: function () {
      this.changePaginationPage(this.currentPagingationPage);
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getSecurityRequests(page, limit) {
      this.$vs.loading();
      if (page && limit) {
        this.filter.page = page ? page : 1;
        this.filter.limit = limit ? limit : 20;
      }

      this.$load(async () => {
        let res = (await this.$api.security.getSecurityRequests(this.filter))
          .data;

        this.totalRequests = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalRequests / this.countElements
        );

        res.results.forEach((request) => {
          request.date_created = DateTime.fromISO(
            request.date_created
          ).toFormat("dd.MM.yyyy HH:mm");

          request.status = this.statusType.find((x) => x.id == request.status);

          request.home.county_type = this.countyType.find(
            (x) => x.id == request.home.county_type
          );
        });

        this.securityRequests = res.results;
        this.$vs.loading.close();
      });
    },
    changePaginationPage(page) {
      this.getSecurityRequests(page, this.countElements);
    },
  },
  created() {},
  mounted() {
    this.getSecurityRequests();
  },
};
</script>